import React from 'react';
import { Button, DotBounceLoading, Icon, Text } from 'mintel-react-ui';
import { mintelGray400 } from 'mintel-tokens';
import NavLoading from '../NavLoading';

import styles from './Authentication.scss';

export const RedirectMessage = (): JSX.Element => (
  <div className={styles.container}>
    <Text.Heading1>Redirecting</Text.Heading1>
    <div className={styles.spaceUp}>
      <DotBounceLoading />
    </div>
  </div>
);

export const SessionLost = (): JSX.Element => (
  <NavLoading>
    <div className={styles.container}>
      <div>
        <Text.Heading1>Session Expired</Text.Heading1>
      </div>
      <Text.Heading2>
        Your session has expired. Please log in again.
      </Text.Heading2>
      <div className={styles.spaceUp}>
        <Icon color={mintelGray400} size={50} name="clock" ariaHidden />
      </div>
      <Button.CallToActionButton
        href={window.location.search.replace('?path=', '')}
      >
        Back to login
      </Button.CallToActionButton>
    </div>
  </NavLoading>
);
